import React, { useEffect, useState } from "react";
import { Button, Form, InputGroup } from "react-bootstrap";
import api from "../../api";
import Can from "../../components/Can";
import AddProjectDialog from "./AddProjectDialog";

// Phase 4C, §10/§11. Project dropdown sourced from GET
// /form-assignment-options/projects — already user-scoped server-side
// (Admin sees every active project; anyone else sees only projects they
// own/manage/are an active member of). "+ Add Project" is gated by the
// EXISTING projects.create permission via <Can>, not by anything specific
// to this wizard.
export default function FormAssignmentProjectSelector({ value, onChange, isDisabled = false }) {
  const [projects, setProjects] = useState([]);
  const [loading, setLoading] = useState(false);
  const [showAdd, setShowAdd] = useState(false);

  const fetchProjects = async () => {
    setLoading(true);
    try {
      const res = await api.get("/form-assignment-options/projects", { params: { pageSize: 200 } });
      setProjects(Array.isArray(res.data?.data) ? res.data.data : []);
    } catch (err) {
      console.error("Fetch assignable projects error:", err);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchProjects();
  }, []);

  const handleCreated = (project) => {
    setShowAdd(false);
    fetchProjects().then(() => onChange(project.id));
  };

  return (
    <>
      <InputGroup>
        <Form.Select value={value || ""} disabled={isDisabled || loading} onChange={(e) => onChange(e.target.value)}>
          <option value="">{loading ? "Loading projects..." : "Select project..."}</option>
          {projects.map((p) => (
            <option key={p.id} value={p.id}>{p.name}</option>
          ))}
        </Form.Select>
        <Can moduleKey="projects" actionKey="create">
          <Button variant="outline-secondary" type="button" onClick={() => setShowAdd(true)} disabled={isDisabled}>
            + Add Project
          </Button>
        </Can>
      </InputGroup>

      <AddProjectDialog show={showAdd} onClose={() => setShowAdd(false)} onCreated={handleCreated} />
    </>
  );
}
